._inviteAlertBanner_quumg_1 {
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
}